module.exports = __webpack_public_path__ + "media/images/flags/4x3/bes-082ccd6db5def537c82a37824737b41f.svg";